import { V1AssetRequest } from '@blk/portfolio-security-server/asset';
import { IdentifiersMap } from '@ddt-web/domain';

export interface SecurityResolutionDetailsRequest {
	securities: Array<SecurityIdentifiersMapRequest>;
}

export interface SecurityIdentifiersMapRequest {
	id?: string;
	identifiers: IdentifiersMap;
}

export interface AssetResolveRequest {
	assetRequests: Array<V1AssetRequest>;
	rc: string;
	asOfDate?: string;
	pkg?: string;
	date?: string;
};

export const IDENTIFIER_TYPE = {
	morningstarSecId: 'ASSET_IDENTIFIER_TYPE_MORNINGSTAR_SEC_ID',
	clientId: 'ASSET_IDENTIFIER_TYPE_CLIENT_ID',
	bcusip: 'ASSET_IDENTIFIER_TYPE_BCUSIP',
	cusip: 'ASSET_IDENTIFIER_TYPE_CUSIP',
	sedol: 'ASSET_IDENTIFIER_TYPE_SEDOL',
	isin: 'ASSET_IDENTIFIER_TYPE_ISIN',
	ric: 'ASSET_IDENTIFIER_TYPE_RIC',
	wkn: 'ASSET_IDENTIFIER_TYPE_WKN',
	valoren: 'ASSET_IDENTIFIER_TYPE_VALOR',
	ticker: 'ASSET_IDENTIFIER_TYPE_TICKER',
	modelId: 'ASSET_IDENTIFIER_TYPE_MODEL_ID'
};
